export default {
    computed: {
        isLoading() {
            return (
                this.onLoading('save-order-layout') ||
                this.onLoading('fetch-order-layout')
            );
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/order-layout/mixins/loading.js